/**
 * Simple facade to manipulate query string parameters
 */
export default class QueryString {
  /**
   * Callback executed when the query string parameters change
   * Override to change default behavior when updating parameters,
   * which is to replace the window.location with the new URL
   */
  onChange = url => history.replaceState(null, null, url.toString())

  /**
   * Default constructor
   * 
   * @param {String} url URL that will be used to parse and manipulate query string params
   */
  constructor (url = document.location.href) {
    this.url = new URL(url)
  }

  /**
   * Retrieve value of a given query string parameter
   * 
   * @param {String} name name of the query string parameter
   * @returns false if the parameter does not exist, the value (can be an empty string) otherwise
   */
  get (name) {
    return this.url.searchParams.get(name)
  }

  /**
   * Set a value of a given query string parameter
   * 
   * @param {String} name name of the query string parameter
   * @param {String} value value of the query string parameter
   */
  set (name, value) {
    if (this.exists(name))
      this.url.searchParams.set(name, value)
    else
      this.url.searchParams.append(name, value)
    this.url.search = this.url.searchParams.toString()
    this.onChange(this.url)
  }

  /**
   * Check if a given query string parameter exists in the query string
   * 
   * @param {String} name name of the query string parameter
   * @returns true if the parameter exists, false otherwise
   */
  exists (name) {
    return this.url.searchParams.get(name) != null
  }

  /**
   * Remove the given parameter from the query string
   * 
   * @param {String} name 
   */
  delete (name) {
    this.url.searchParams.delete(name)
    this.onChange(this.url)
  }
}



// WEBPACK FOOTER //
// ./src/utils/QueryString.js